import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'
import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import tr, { CONFIRM_POLY_PLANNING_LEVEL_KEY } from './translations'

import styles from './ConfirmPolyPlanningLevelDialogContent.module.scss'

interface IProps {
  newPolyPlanningLevel: string
  onConfirm: () => void
  onClose: () => void
}

export const ConfirmPolyPlanningLevelDialogContent = ({
  newPolyPlanningLevel,
  onConfirm,
  onClose,
}: IProps) => {
  const messageKey = useMemo(() => {
    return `${CONFIRM_POLY_PLANNING_LEVEL_KEY}--${(newPolyPlanningLevel || '').toLowerCase()}`
  }, [newPolyPlanningLevel])

  return (
    <div className={styles.root}>
      <WidgetHeader>{tr.title}</WidgetHeader>

      <div className={styles.message}>
        <Translation text={messageKey} span htmlAvailable />
      </div>

      <div className={styles.btns}>
        <Button className={styles.btns__btn} onClick={onConfirm}>
          <Translation text={tr.apply} />
        </Button>
        <Button color="grey" onClick={onClose}>
          <Translation text={tr.cancel} />
        </Button>
      </div>
    </div>
  )
}
